module.exports = __webpack_public_path__ + "static/media/walletD.86b05c16.svg";